// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color-picker__color{box-shadow:inset 0 0 2px 0 rgba(0,0,0,.8)}.color-picker--name-centered{display:inline-block;position:relative;width:32px}.color-picker__name{left:50%;position:absolute;top:24px;transform:translateX(-50%);white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
